/* global G */
import { curry } from 'lib/util'
import searchWith from 'app/_shared/events/search/with'
import infinite from 'app/_shared/events/search/infinite'
import { date, sortBy } from 'lib/util/array'

const recentItems = async (module, component, event) => {
  const settingsAdapter = module[G.ADAPTER][G.SETTINGS]

  const { recents = [] } = settingsAdapter[G.DATA]
  const recentsIds = recents.map(r => r.key)

  if (!recents.length) {
    return { data: [] }
  }

  const withEvent = { ...event, detail: { ids: recentsIds } }
  const { query } = await searchWith(['query'], module, component, withEvent)

  const searchEvent = { ...event, detail: { query } }
  const result = await infinite('default', module, component, searchEvent)

  const data = recents
    .filter(r => result.data.find(x => x.key === r.key))
    .map((r, i) => {
      const foundRecent = result.data.find(x => x.key === r.key)

      return {
        ...foundRecent,
        key: i,
        meta: { type: r.type },
        timestamp: r.timestamp,
        value: {
          ...foundRecent.value,
          id: foundRecent.key,
        },
      }
    })

  return {
    data: sortBy(data, date('timestamp')),
  }
}

export default curry(recentItems)
